import { CssBaseline, CssBaselineProps } from '@mui/material'
import React, { FC } from 'react'

const CssBaselineWrapper: FC<CssBaselineProps> = ({ ...props }) => <CssBaseline {...props} />

export default CssBaselineWrapper
